import gsap from 'gsap';
import Lenis from '@studio-freight/lenis';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export const initSmoothScrolling = () => {
    // 先注册，再配置
    gsap.registerPlugin(ScrollTrigger);

    // 禁止 GSAP 在 resize 时自动刷新触发器位置
    // 移动端地址栏收起/展开会触发 resize，但我们不希望因此重算动画时机
    // 改由下方自定义 handler 只在真实 resize 时刷新
    ScrollTrigger.config({
        autoRefreshEvents: 'visibilitychange,DOMContentLoaded,load',
    });

    const lenis = new Lenis({
        lerp: 0.1,
        smoothWheel: true,
    });

    lenis.on('scroll', () => ScrollTrigger.update());

    const scrollFn = (time: number) => {
        lenis.raf(time);
        requestAnimationFrame(scrollFn);
    };
    requestAnimationFrame(scrollFn);

    // 区分移动端地址栏/工具栏 resize 和真实 resize（横竖屏、窗口拖拽）
    // 移动端宽度不变的高度变化通常来自浏览器 chrome，不刷新 ScrollTrigger
    // 真实 resize：宽度变化 或 高度变化 >100px → 同步刷新两者
    let prevWidth = window.innerWidth;
    let prevHeight = window.innerHeight;
    let resizeTimer: ReturnType<typeof setTimeout>;

    const handleResize = () => {
        const widthChanged = window.innerWidth !== prevWidth;
        const heightDelta = Math.abs(window.innerHeight - prevHeight);
        const isTouchViewport = navigator.maxTouchPoints > 0;
        const isBrowserChromeResize = isTouchViewport && !widthChanged;
        const isRealResize =
            !isBrowserChromeResize && (widthChanged || heightDelta > 100);

        if (isRealResize) {
            prevWidth = window.innerWidth;
            prevHeight = window.innerHeight;
            lenis.resize();
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                requestAnimationFrame(() => {
                    ScrollTrigger.refresh(true);
                });
            }, 100);
        }
    };
    window.addEventListener('resize', handleResize);

    return lenis;
};
